import { render } from "./GridSupplier.vue?vue&type=template&id=4f528c31"
import script from "./GridSupplier.vue?vue&type=script&lang=js"
export * from "./GridSupplier.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__